import { render, staticRenderFns } from "./GlobalSettingsEdit.vue?vue&type=template&id=2c8ea1d3&scoped=true&"
import script from "./GlobalSettingsEdit.vue?vue&type=script&lang=js&"
export * from "./GlobalSettingsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSettingsEdit.vue?vue&type=style&index=0&id=2c8ea1d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ea1d3",
  null
  
)

export default component.exports